import React, { useState } from 'react';
import { getBaseUrl } from '../config';
import { useToast } from './Toast';

const SqlExport = () => {
    const [fileName, setFileName] = useState(() => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        return `injee_export_${year}${month}${day}${hours}${minutes}${seconds}`;
    });
    const [isLoading, setIsLoading] = useState(false);
    const [includeStructure, setIncludeStructure] = useState(true);
    const [includeData, setIncludeData] = useState(true);
    const [includeValues, setIncludeValues] = useState(false);
    const [compress, setCompress] = useState(false);
    const showToast = useToast();

    const handleExportSql = async () => {
        if (!fileName) {
            showToast('Error: Please provide a file name.', 'error');
            return;
        }

        setIsLoading(true);

        try {
            // Append .sql extension if not present
            const fullFileName = fileName.endsWith('.sql') ? fileName : `${fileName}.sql`;
            // The backend endpoint as per readme: /ops/sql?file=backups/FILE.sql
            let url = `${getBaseUrl()}/ops/sql?file=backups/${fullFileName}`;

            // Note: If the backend supports these parameters, they will be appended.
            // Based on typical patterns in this app.
            if (compress) url += '&compress=true';
            if (!includeStructure) url += '&structure=false';
            if (!includeData) url += '&data=false';
            if (includeValues) url += '&values=true';

            const response = await fetch(url, {
                method: 'GET'
            });

            if (response.ok) {
                showToast(`Successfully exported to backups/${fullFileName}`, 'success');
            } else {
                const data = await response.json().catch(() => ({}));
                showToast(`Error: ${data.message || 'Failed to export SQL'}`, 'error');
            }
        } catch (error) {
            showToast(`Error: ${error.message}`, 'error');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <h2 className="title is-3">SQL Export</h2>
            <p className="subtitle">Export database structure and data as SQL</p>
            <div className="content">
                <p>Generate SQL dump files containing your database structure and data.</p>

                <div className="field" style={{ maxWidth: '400px', marginBottom: '1.5rem' }}>
                    <label className="label">Export File Name</label>
                    <div className="control">
                        <input
                            className="input is-link"
                            type="text"
                            placeholder="Enter file name"
                            value={fileName}
                            onChange={(e) => setFileName(e.target.value)}
                            disabled={isLoading}
                        />
                    </div>
                </div>

                <div className="field">
                    <label className="checkbox">
                        <input
                            type="checkbox"
                            checked={includeValues}
                            onChange={(e) => setIncludeValues(e.target.checked)}
                            disabled={isLoading}
                        />
                        {' '}Include Values
                    </label>
                </div>

                <button
                    className={`button is-info ${isLoading ? 'is-loading' : ''}`}
                    onClick={handleExportSql}
                    disabled={isLoading}
                    style={{ marginTop: '1rem' }}
                >
                    <span className="icon">
                        <i className="bi bi-file-earmark-code"></i>
                    </span>
                    <span>Export SQL</span>
                </button>
            </div>
        </div>
    );
};

export default SqlExport;
